/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "overages-shortages",

    getDefaultProps: function getDefaultProps() {
        return {
            "overagesShortages": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "52.3",
            "height": "55.5"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 52.3 55.5", className: "overages-shortages", width: this.props.width, height: this.props.height, style: this.props.overagesShortages },
            _react2["default"].createElement("path", { fill: "#999", d: "M48.84 3.173l3.535 3.535-48.79 48.79L.05 51.963zM15.9 0v11.3h10.9v4.9H15.9v11.4h-5.1V16.2H0v-4.9h10.9V0h5zM25.3 41.9h27v4.9h-27z" })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/overages-shortages.js